// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","headWrap":"headWrap__2wEyN","logo":"logo__35n-0","boooooooi":"boooooooi__2ZdGe","active":"active__3gItZ","backArrow":"backArrow__jbqGv"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 12